import ReceiptForm from './ReceiptFrom';

export default ReceiptForm;